enum InputDataType {
    Structure,
    Sequence,
}

export default InputDataType;
